import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";
import { IoCash, IoCashOutline } from "react-icons/io5";
import { Col, FormFeedback, FormGroup, Input, Label, Row } from "reactstrap";
import { GetLanguageString } from "../../../helper/Components";
const CashToAmanatForm = ({
  values,
  errors,
  fundAccountBalances,
  handleInputChange,
  handleDateChange,
  handleFileChange,
  isEdit = false,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <style>{`
        .balance-card-hover:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 12px rgba(0,0,0,0.08) !important;
        }
        @keyframes bounce-dots {
          0%, 80%, 100% { transform: scale(0); }
          40% { transform: scale(1.0); }
        }
        .bouncing-loader {
          display: flex;
          align-items: center;
          height: 24px;
          margin-top: 4px;
        }
        .bouncing-loader span {
          width: 8px;
          height: 8px;
          margin: 0 3px;
          background-color: currentColor;
          border-radius: 50%;
          display: inline-block;
          animation: bounce-dots 1.4s infinite ease-in-out both;
        }
        .bouncing-loader span:nth-child(1) { animation-delay: -0.32s; }
        .bouncing-loader span:nth-child(2) { animation-delay: -0.16s; }
      `}</style>
      {/* BALANCE CARDS */}
      <Row style={{ marginBottom: "20px" }}>
        {/* Cash Account Balance */}
        <Col xs="6" md="6" xl="6" className="mb-3">
          <div
            style={{
              padding: "12px 20px",
              backgroundColor: "#ffffff",
              borderRadius: "8px",
              border: "1px solid #e7eaec",
              borderLeft: "5px solid #1ab394",
              boxShadow: "0 4px 6px rgba(0,0,0,0.03)",
              transition: "transform 0.2s, box-shadow 0.2s",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
            className="balance-card-hover"
          >
            <div>
              <div style={{ fontSize: "11px", textTransform: "uppercase", color: "#888888", fontWeight: "600", letterSpacing: "0.5px" }}>
                <GetLanguageString props="cash_account_balance" />
              </div>
              <div style={{ fontSize: "24px", fontWeight: "700", marginTop: "4px", color: "#1ab394" }}>
                {!fundAccountBalances || fundAccountBalances.cashAccountBalance === undefined ? (
                  <div className="bouncing-loader">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                ) : (
                  new Intl.NumberFormat().format(fundAccountBalances.cashAccountBalance)
                )}
              </div>
            </div>
            <div style={{ backgroundColor: "#e8f7f4", padding: "10px", borderRadius: "50%" }}>
              <IoCashOutline style={{ color: "#1ab394", fontSize: "26px" }} />
            </div>
          </div>
        </Col>

        {/* Amanat Account Balance */}
        <Col xs="6" md="6" xl="6" className="mb-3">
          <div
            style={{
              padding: "12px 20px",
              backgroundColor: "#ffffff",
              borderRadius: "8px",
              border: "1px solid #e7eaec",
              borderLeft: "5px solid #3b82f6",
              boxShadow: "0 4px 6px rgba(0,0,0,0.03)",
              transition: "transform 0.2s, box-shadow 0.2s",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
            className="balance-card-hover"
          >
            <div>
              <div style={{ fontSize: "11px", textTransform: "uppercase", color: "#888888", fontWeight: "600", letterSpacing: "0.5px" }}>
                <GetLanguageString props="transactions_amanat_account_balance" />
              </div>
              <div style={{ fontSize: "24px", fontWeight: "700", marginTop: "4px", color: "#3b82f6" }}>
                {!fundAccountBalances || fundAccountBalances.amanatAccountBalance === undefined ? (
                  <div className="bouncing-loader">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                ) : (
                  new Intl.NumberFormat().format(fundAccountBalances.amanatAccountBalance)
                )}
              </div>
            </div>
            <div style={{ backgroundColor: "#eff6ff", padding: "10px", borderRadius: "50%" }}>
              <IoCash style={{ color: "#3b82f6", fontSize: "24px" }} />
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        {/* FORM FIELDS */}

        {/* Transfer Amount */}
        <Col md="6">
          <FormGroup>
            <Label className="col-form-label">
              <GetLanguageString props="funds_add_fund_amount" />
            </Label>
            <Input
              type="text"
              name="transferAmount"
              placeholder={t("funds_add_fund_amount")}
              value={values.transferAmount}
              onChange={(e) => {
                const val = e.target.value;
                if (/^\d*$/.test(val)) {
                  handleInputChange({
                    target: { name: "transferAmount", value: val },
                  });
                }
              }}
              invalid={!!errors.transferAmount}
            />
            {errors.transferAmount && (
              <FormFeedback>
                <h4>{errors.transferAmount}</h4>
              </FormFeedback>
            )}
          </FormGroup>
        </Col>

        {/* Bank Charges */}
        {!isEdit && (
          <Col md="6">
            <FormGroup>
              <Label className="col-form-label">
                <GetLanguageString props="transactions_bank_charges" />
              </Label>
              <Input
                type="text"
                name="bankCharge"
                placeholder="Bank Charges"
                value={values.bankCharge}
                onChange={handleInputChange}
                invalid={!!errors.bankCharge}
              />
            </FormGroup>
          </Col>
        )}
        {/* Deposit Date */}
        <Col md="6">
          <FormGroup>
            <Label className="col-form-label">
              <GetLanguageString props="dashboard_event_page_date" />
            </Label>
            <DatePicker
              selected={values.depositDate}
              onChange={handleDateChange}
              className={`form-control ${errors.depositDate ? "is-invalid" : ""
                }`}
              maxDate={new Date()}
              dateFormat="dd/MM/yyyy"
            />
            {errors.depositDate && (
              <div className="invalid-feedback d-block">
                <h4>{errors.depositDate}</h4>
              </div>
            )}
          </FormGroup>
        </Col>

        {/* Reference No */}
        <Col md="6">
          <FormGroup>
            <Label className="col-form-label">
              <GetLanguageString props="transactions_bank_deposit_slip_number" />
            </Label>
            <Input
              type="text"
              name="referenceNo"
              placeholder="Bank Deposit Slip Number"
              value={values.referenceNo || ""}
              onChange={(e) =>
                handleInputChange({
                  target: { name: "referenceNo", value: e.target.value },
                })
              }
              invalid={!!errors.referenceNo}
            />
            {errors.referenceNo && (
              <div className="invalid-feedback d-block">
                <h4>{errors.referenceNo}</h4>
              </div>
            )}
          </FormGroup>
        </Col>

        {/* File Upload */}
        <Col md="6">
          <FormGroup>
            <Label className="col-form-label">
              <GetLanguageString props="deposit_slip" />
            </Label>
            <Input
              type="file"
              accept="image/*,application/pdf"
              name="file"
              onChange={handleFileChange}
              invalid={!!errors.file}
            />
            {errors.file && (
              <FormFeedback>
                <h4>{errors.file}</h4>
              </FormFeedback>
            )}
          </FormGroup>
        </Col>

        {/* Memo */}
        <Col md={isEdit ? "12" : "6"}>
          <FormGroup>
            <Label className="col-form-label">
              <GetLanguageString props="transactions_memo" />
            </Label>
            <Input
              type="textarea"
              name="memo"
              placeholder="Memo"
              value={values.memo}
              onChange={handleInputChange}
            />
          </FormGroup>
        </Col>
      </Row>
    </>
  );
};
export default CashToAmanatForm;
